export default __webpack_public_path__ + "static/media/LoginScreen.4d6d1e14.svg";